import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface EmbeddingCountResponse {
  count: number;
}

export const useGetEmbeddingCount = () => {
  const { workspaceId } = useParams();
  const authContext = useAuth();

  return useQuery<EmbeddingCountResponse>({
    queryKey: ["embedding-count", workspaceId],
    queryFn: async () => {
      const response = await fetch(ENDPOINTS.embedding_count(workspaceId || ""), {
        method: "GET",
        headers: jsonAuthHeaders(authContext?.userToken ?? ""),
      });
      return handleResponse(response);
    },
    enabled: !!authContext?.userToken && !!workspaceId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
